import React, { useId, useState } from 'react'
import { Plus } from 'lucide-react'
import { cx } from '@/lib/utils'
import styles from './Collapse.module.scss'

interface CollapseProps {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
}

export const Collapse: React.FC<CollapseProps> = ({ title, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen)
  const panelId = useId()

  return (
    <div className={styles.collapse}>
      <button
        type="button"
        className={styles.trigger}
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-controls={panelId}
      >
        <span>{title}</span>
        <Plus size={20} className={cx(styles.icon, open && styles.iconOpen)} />
      </button>
      <div id={panelId} className={cx(styles.content, open && styles.contentOpen)}>
        <div className={styles.inner}>
          <div className={styles.body}>{children}</div>
        </div>
      </div>
    </div>
  )
}
